import { render, staticRenderFns } from "./Needs.vue?vue&type=template&id=3e608f50&scoped=true&"
import script from "./Needs.vue?vue&type=script&setup=true&lang=js&"
export * from "./Needs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e608f50",
  null
  
)

export default component.exports